import React, { useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { ia, iaRa, inRn } from 'lib/helpers/utility';

import {
  calcInvoiceDiscountFromProducts,
  calculateInvoiceTaxFromItems
} from 'components/practice/NewAppointment/components/Sections/Pricing/components/ProceduresProduct/components/SelectedItems/helpers';
import { permissions } from 'components/state';

import ReceiptTable from '../ReceiptTable/ReceiptTable';

import { ITEMS_TABLE_COLUMNS } from './lib/columnDefs';

const ReceiptItems = ({ transaction }) => {
  const userPermissions = useRecoilValue(permissions);

  const { invoice, isPatient } = transaction || {};

  const items = [
    ...iaRa(invoice?.procedures),
    ...iaRa(invoice?.products),
    ...iaRa(invoice?.packages)
  ];

  const hasItems = ia(items);

  const columnDefs = useMemo(() => ITEMS_TABLE_COLUMNS(userPermissions, isPatient, hasItems), []);

  const amountRefunded = inRn(transaction?.amount_refunded);
  const amountPaid = inRn(transaction?.amount_paid_self) - inRn(transaction?.surcharge_amount);

  const modifiedItems = iaRa(items).map((item) => {
    const { pt_balance, total_cost_cents, total_amount_cents, discount, type, invoiceId } =
      item || {};
    const price = pt_balance ?? total_cost_cents ?? total_amount_cents ?? 0;
    let discountValue = discount?.amount_cents || 0;

    let taxAmount = calculateInvoiceTaxFromItems({ mergedItems: [item] });

    const isService = type || invoiceId;

    if (item?.products?.length || item?.procedures?.length) {
      taxAmount = calculateInvoiceTaxFromItems(item);

      const invoiceDiscount = calcInvoiceDiscountFromProducts(item);
      discountValue = invoiceDiscount?.amount_cents || 0;
    }

    const qty =
      (isService ? (item?.quantity ?? item?.units ?? item?.sales_count) : item?.sales_count) || 1;

    const total = price * qty - discountValue + taxAmount;

    return {
      ...item,
      price,
      quantity: qty,
      discount: discountValue,
      tax: taxAmount,
      total
    };
  });

  const noItems = !hasItems ? [{ charge: amountPaid + amountRefunded }] : [];

  return (
    <ReceiptTable
      items={hasItems ? modifiedItems : noItems}
      columns={columnDefs}
      footer={hasItems}
    />
  );
};

export default ReceiptItems;
